import Semed from "../Semed";

class Search {
  async all (words) {
    return Semed.get('search?search=' + words + '&origin=educacao.santarem.pa.gov.br')
  }
  async quick (words) {
    return Semed.get('quick-search?search=' + words + '&origin=educacao.santarem.pa.gov.br')
  }
  async get (url) {
    return Semed.get(url)
  }
}

export default new Search()
